import React from "react";
var __jsx = React.createElement;
import BreadCrumb from "@componentsShared/BreadCrumb";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import PageDesc from "./components/PageDesc/PageDesc";
import RecTrendingCars from "./components/RecTrendingCars/RecTrendingCars";
import PostsContainer from "./components/PostsContainer/PostsContainer";
import stl from "./SingleTrendComponent.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var paramsToQueryString = function paramsToQueryString(params) {
  return Object.keys(params).map(function (key) {
    if (!params[key]) return null;
    return "".concat(key, "=").concat(params[key]);
  }).filter(Boolean).join("&");
};
var SingleTrendComponent = function SingleTrendComponent(_ref) {
  var _posts, _trend$similar;
  var trend = _ref.trend,
    posts = _ref.posts,
    similarItems = _ref.similarItems;
  var _useTranslation = useTranslation(["web_trend"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  posts = ((_posts = posts) === null || _posts === void 0 ? void 0 : _posts.length) > 0 ? posts : (similarItems === null || similarItems === void 0 ? void 0 : similarItems.length) > 0 ? similarItems : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.ST_container, "max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto"].join(" ")
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("سيارة ترند", {
        ns: "web_common"
      }),
      link: createUrl("/trend")
    }, {
      title: t(trend === null || trend === void 0 ? void 0 : trend.h1_tag, {
        ns: "web_common"
      })
    }],
    noCurrency: true
  }), /*#__PURE__*/React.createElement("h1", {
    className: "no-currency-icon"
  }, trend === null || trend === void 0 ? void 0 : trend.h1_tag), /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 1025px)",
    srcSet: trend === null || trend === void 0 ? void 0 : trend.hero_img_desktop
  }), /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 1024px)",
    srcSet: trend === null || trend === void 0 ? void 0 : trend.hero_img_mobile
  }), /*#__PURE__*/React.createElement("img", {
    src: trend === null || trend === void 0 ? void 0 : trend.hero_img_desktop,
    alt: trend === null || trend === void 0 ? void 0 : trend.h1_tag,
    width: "1152px",
    height: "350px",
    loading: "eager"
  })), /*#__PURE__*/React.createElement("p", {
    className: "no-currency-icon"
  }, trend === null || trend === void 0 ? void 0 : trend.hero_desc), posts.length === 0 ? null : /*#__PURE__*/React.createElement(PostsContainer, {
    posts: posts
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "redBtn ".concat(stl.customBtn),
    onClick: function onClick() {
      return navigateTo("/filters?".concat(paramsToQueryString(trend === null || trend === void 0 ? void 0 : trend.filters)));
    },
    loading: false
  }, t("تصفح جميع السيارات", {
    ns: "web_common"
  })), " ", /*#__PURE__*/React.createElement(PageDesc, {
    content: trend === null || trend === void 0 ? void 0 : trend.page_desc
  }), trend !== null && trend !== void 0 && (_trend$similar = trend.similar) !== null && _trend$similar !== void 0 && _trend$similar.length ? /*#__PURE__*/React.createElement(RecTrendingCars, {
    similar: trend === null || trend === void 0 ? void 0 : trend.similar
  }) : null));
};
export default SingleTrendComponent;